/**
 * reCAPTCHA v3 — helper partilhado (carregamento lazy)
 *
 * A API do Google (api.js) NÃO é carregada no load da página. É injetada apenas
 * na primeira interação com um formulário (focusin) ou na primeira chamada a
 * getToken() — o que ocorrer primeiro. Isto remove o script de 3ª parte do
 * caminho crítico de render sem perder proteção.
 *
 * window.hcpRecaptcha.getToken(action) devolve uma Promise que resolve com um
 * token fresco (single-use). Se o reCAPTCHA não estiver ativo, resolve com
 * string vazia — o servidor trata isso (fail-open quando não configurado,
 * fail-closed quando configurado).
 */
(function () {
    "use strict";

    var apiPromise = null;

    function loadApi() {
        if (apiPromise) {
            return apiPromise;
        }

        var cfg = window.hcpRecaptchaCfg || {};

        apiPromise = new Promise(function (resolve) {
            if (!cfg.enabled || !cfg.siteKey) {
                resolve(false);
                return;
            }
            // Já presente?
            if (typeof grecaptcha !== "undefined") {
                resolve(true);
                return;
            }
            var s = document.createElement("script");
            s.src =
                "https://www.google.com/recaptcha/api.js?render=" +
                encodeURIComponent(cfg.siteKey);
            s.async = true;
            s.defer = true;
            s.onload = function () {
                resolve(true);
            };
            s.onerror = function () {
                resolve(false);
            };
            document.head.appendChild(s);
        });

        return apiPromise;
    }

    // Pré-carrega na primeira interação com qualquer formulário (melhora o score
    // v3 sem bloquear o render inicial).
    function onFirstInteraction(e) {
        if (e.target && e.target.closest && e.target.closest("form")) {
            loadApi();
            document.removeEventListener("focusin", onFirstInteraction, true);
        }
    }
    document.addEventListener("focusin", onFirstInteraction, true);

    window.hcpRecaptcha = {
        getToken: function (action) {
            return new Promise(function (resolve) {
                loadApi().then(function (ok) {
                    if (!ok || typeof grecaptcha === "undefined") {
                        resolve("");
                        return;
                    }
                    grecaptcha.ready(function () {
                        grecaptcha
                            .execute(window.hcpRecaptchaCfg.siteKey, {
                                action: action || "submit",
                            })
                            .then(resolve)
                            .catch(function () {
                                resolve("");
                            });
                    });
                });
            });
        },
    };
})();
